<template>
  <v-container class="h-auto pa-4" fluid>
    <v-row justify="center" class="h-100">
      <v-sheet class="bg-background flex-1-1 px-4" max-width="420">
        <div class="text-h5 text-center mb-8 font-weight-medium">Create a Team</div>
      </v-sheet>
    </v-row>
    <v-row justify="center" class="h-100">
      <v-sheet class="bg-background flex-1-1 pa-4" max-width="600">
        <TeamEditComponent
          :team="regForm"
          :isCreate="true"
          :allow-close="false"
          @teamEditComplete="handleTeamEditComplete"></TeamEditComponent>
      </v-sheet>
    </v-row>
  </v-container>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { ITeamDTO, TeamDTO } from '@/dtos';
import TeamEditComponent from '@/components/teams/TeamEditComponent.vue';

const router = useRouter();
const regForm = ref<ITeamDTO>(new TeamDTO());

const handleTeamEditComplete = async () => {
  router.push({ name: 'Home' });
};
</script>
